
<template>
  <div class="ui fluid card">
    <div class="content">
      <i class="right floated green check icon" v-if="data.live && data.archive "></i>
      <a v-if="!data.live && !data.archive && !edit"><i class="right floated pencil icon" v-on:click.prevent="initTextedit()"></i></a>
      <a v-if="!data.live && !data.archive && edit"><i class="right floated close icon" v-on:click.prevent="edit=false"></i></a>
      <div class="header">{{ data.author }}</div>

      <div class="meta">
        <span class="category">{{ data.email }}</span>
      </div>

      <div class="description" v-if="edit">
        <div class="ui form">
          <div class="field">
            <textarea v-model="questiontextarea"></textarea>
          </div>
          <div class="ui submit button" v-on:click.prevent="saveTextedit()">speichern</div>
        </div>
      </div>


      <div class="description" v-else>
        <p style="white-space: pre-wrap; word-wrap: break-word;" v-if="data.modifiedQuestion">{{ data.modifiedQuestion }}</p>
        <p style="white-space: pre-wrap; word-wrap: break-word;" v-else>{{ data.question }}</p>
      </div>

      <div class="ui message" v-if="(edit || data.archive) && data.modifiedQuestion">
        <div class="header">
          Original
        </div>
        <p style="white-space: pre-wrap; word-wrap: break-word;">{{ data.question }}</p>
      </div>
    </div>
    <div class="extra content">
      <span class="time">{{ _createTimestamp(data.timestamp) }}</span>
      <span class="right floated noprint" v-if="!data.archive" v-on:click="goForward()">
        <a><i class="check icon"></i></a>
      </span>
      <span class="right floated noprint" v-if="!(data.archive || data.live)" style="margin-right:2em;">
        <a><i class="archive icon" v-on:click="goArchive()"></i></a>
      </span>
      <span class="right floated noprint" v-if="data.archive || data.live" style="margin-right:2em;">
        <a><i class="undo icon" v-on:click="goBack()"></i></a>
      </span>
    </div>
  </div>
</template>

<script>
  /*global $:true*/
  import moment from 'moment'
  import EventBus from './event-bus';

  export default {
    name: 'QuestionsListItem',
    props: { 
      data: Object,
    },

    data: function() {
      return {
        edit: false,
        questiontextarea: ""
      }
    },

    created: function(){
      moment.locale('de-DE')
    },

    mounted: ()=> {},

    methods: {
      initTextedit() {
        if(this.data.modifiedQuestion && this.data.modifiedQuestion.length > 0)
          this.questiontextarea = this.data.modifiedQuestion; 
        else
          this.questiontextarea = this.data.question; 
        this.edit=true;
      },

      saveTextedit() {
        this.modifiedQuestion = this.questiontextarea

        let newObj = { ...this.data }
        newObj.changedAt = Date.now()
        newObj.modifiedQuestion = this.questiontextarea

        this.updateObject(newObj)

        this.edit = false;
      },

      _createTimestamp: function (d) {
        //return moment(d).fromNow();
        return moment(d).format('DD.MM.YY HH:mm')
      },

      goArchive: function() {
        let newObj = { ...this.data }
        newObj.archive = true
        newObj.changedAt = Date.now()

        EventBus.$emit('goArchive', newObj)
        this.updateObject(newObj)
      },

      goForward: function() {
        let newObj = { ...this.data }
        newObj.changedAt = Date.now()
        
        if(this.data.live) {
          newObj.archive = true
        } else {
          newObj.live = true
        }

        EventBus.$emit('goForward', newObj)
        this.updateObject(newObj)
      },

      goBack: function() {
        let newObj = { ...this.data }
        newObj.changedAt = Date.now()

        if(!this.data.archive)
          newObj.live = false
        newObj.archive = false
        
        EventBus.$emit('goBack', newObj)
        this.updateObject(newObj)
      },

      updateObject: function(obj) {
        const m = {
          "action":"update",
          "streamid": this.$root.streamid,
          "auth": this.$root.password,
          "obj": obj
        };
        this.$root.connection.send( JSON.stringify(m) );
      },
    }
  }
</script>

<style scoped>
  @media print {
    .noprint {
      display: none !important;
    }
  }
</style>